import { BatchStpbPrintPage } from "@/features/delivery-order-batch/pages/BatchStpbPrintPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/delivery-order-batch/$deliveryOrderBatchID/stpb",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["delivery_order.batch_generate"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: BatchStpbPrintPage,
});
